import { Node, mergeAttributes } from "@tiptap/core";

export const LinkedinServerside = Node.create({
  name: "linkedin",

  group: "block",
  content: "inline*",

  parseHTML() {
    return [
      {
        tag: 'a[data-type="linkedin"]',
      },
    ];
  },
  addAttributes() {
    return {
      url: { default: null },
      "data-id": { default: null },
      class: { default: "inline-tiktok" },
    };
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-type": "linkedin",
        class: `react-renderer node-linkedin ${HTMLAttributes.class}`,
      }),
      0,
    ];
  },
});
